import { render, staticRenderFns } from "./landingpage.vue?vue&type=template&id=1b9a2980&scoped=true"
import script from "./landingpage.vue?vue&type=script&lang=js"
export * from "./landingpage.vue?vue&type=script&lang=js"
import style0 from "./landingpage.vue?vue&type=style&index=0&id=1b9a2980&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b9a2980",
  null
  
)

export default component.exports